//@ts-expect-error-not typed yet
import BaymaxRevisionsModalContainer from './BaymaxRevisionsModalContainer';
import useThemeRevisions from 'theme-previewer-lib/hooks/useThemeRevisions';
import { fetchRevisions as fetchThemeRevisions, fetchThemeAndSettings, clearRevisions as clearThemeRevisions } from 'theme-previewer-lib/actions/ThemeSettingsActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getThemePath, selectThemeVariantName } from 'ContentEditorUI/js/redux/selectors/themeSelectors';
//@ts-expect-error-not typed yet
import { getPreviewDomain } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import { getContentModelId, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getTemplatePreviewKey } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getRevisions } from 'theme-previewer-lib/selectors/revisionsSelectors';
//@ts-expect-error-not typed yet
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
//@ts-expect-error-not typed yet
import { clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { jsx as _jsx } from "react/jsx-runtime";
const CombinedRevisionsModalContainer = ({
  contentType
}) => {
  var _useSelector;
  const dispatch = useDispatch();
  const themePath = useSelector(getThemePath) || '';
  const themeVariantName = ((_useSelector = useSelector(selectThemeVariantName)) === null || _useSelector === void 0 ? void 0 : _useSelector.toString()) || undefined;
  const previewDomain = useSelector(getPreviewDomain);
  const contentId = useSelector(getContentModelId);
  const previewKey = useSelector(getPreviewKey);
  const templatePreviewKey = useSelector(getTemplatePreviewKey);
  const revisions = useSelector(getRevisions);
  useEffect(() => {
    const handleFetchingThemeRevisions = () => {
      dispatch(fetchThemeRevisions());
    };
    if (!revisions.length) {
      dispatch(fetchThemeAndSettings(themePath, themeVariantName)).then(() => dispatch(handleFetchingThemeRevisions())).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  }, [dispatch, themePath, themeVariantName, revisions]);
  const onClose = () => {
    dispatch(clearSelectedItem());
    dispatch(routeToPage('content'));
    dispatch(clearThemeRevisions());
  };
  const themeRevisionsConfig = useThemeRevisions(previewDomain, contentId, themeVariantName, previewKey, templatePreviewKey);
  return /*#__PURE__*/_jsx(BaymaxRevisionsModalContainer, {
    themeRevisionsConfig: themeRevisionsConfig,
    hasTabs: true,
    contentType: contentType,
    extraPreviewParams: {
      buffer_theme: true
    },
    onClose: onClose
  });
};
export default CombinedRevisionsModalContainer;